import React from 'react';
import { BookOpen, Calendar, Clock, ArrowRight, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export const BlogPage: React.FC = () => {
  const posts = [
    {
      id: 1,
      title: 'How to Keep Your Smurf and Primary Accounts 100% Secure',
      category: 'Security Best Practices',
      date: 'Oct 2, 2026',
      readTime: '5 min read',
      image: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=600',
      snippet: 'Learn how to properly secure purchased full-access accounts with 2-Factor Authentication, email changing workflows, and hardware UUID matching.'
    },
    {
      id: 2,
      title: 'Valorant Act Ranking Meta: Radiant Booster Insights',
      category: 'Boosting & Coaching',
      date: 'Sep 29, 2026',
      readTime: '7 min read',
      image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=600',
      snippet: 'Our collegiate and top-500 boosters break down the strongest agent compositions and retake setups to climb through Ascendant and Immortal.'
    },
    {
      id: 3,
      title: 'Digital Key Encryption: Why Cloudflare Workers & AES-GCM Matter',
      category: 'Marketplace Engineering',
      date: 'Sep 22, 2026',
      readTime: '4 min read',
      image: 'https://images.unsplash.com/photo-1579373903781-fd5c0c30c4cd?w=600',
      snippet: 'A deep architectural dive into how GameVault prevents credential leaks with Web Crypto zero-knowledge encryption and atomic D1 SQLite transactions.'
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-10">
      
      <div className="text-center max-w-2xl mx-auto space-y-3">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-brand-blue/10 text-brand-blue dark:text-brand-accent">
          <BookOpen className="w-3.5 h-3.5" />
          <span>Guides & Market Insights</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-black text-brand-lightText dark:text-brand-darkText">
          GameVault News & Gaming Guides
        </h1>
        <p className="text-xs sm:text-sm text-brand-lightSecText dark:text-brand-darkSecText">
          Expert articles on competitive metas, account security, marketplace economics, and game updates
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {posts.map((post) => (
          <article
            key={post.id}
            className="rounded-3xl overflow-hidden bg-white dark:bg-brand-darkCard border border-brand-lightBorder dark:border-brand-darkBorder shadow-sm hover:shadow-glow-blue transition-all duration-300 flex flex-col"
          >
            <div className="aspect-[16/10] overflow-hidden bg-slate-900">
              <img src={post.image} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
            </div>

            <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
              <div className="space-y-2">
                <span className="text-[10px] font-bold uppercase tracking-wider text-brand-blue dark:text-brand-accent">
                  {post.category}
                </span>
                <h3 className="font-bold text-base text-brand-lightText dark:text-brand-darkText line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-xs text-brand-lightSecText dark:text-brand-darkSecText leading-relaxed line-clamp-3">
                  {post.snippet}
                </p>
              </div>

              <div className="pt-4 border-t border-brand-lightBorder dark:border-brand-darkBorder flex items-center justify-between text-[11px] text-brand-lightSecText">
                <div className="flex items-center gap-2">
                  <Calendar className="w-3.5 h-3.5" />
                  <span>{post.date}</span>
                </div>
                <div className="flex items-center gap-1 font-semibold text-brand-blue dark:text-brand-accent">
                  <span>{post.readTime}</span>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};
